import {VBtn, VProgressLinear} from 'vuetify/lib'
import PageContain from '@/views/components/PageContain.vue'
import VPage from '@/vuetify_custom/v-pagination'
import page_mixins from './page_mixins'
import Edit from './editor.vue'
import GzItem from './GzItem'
import ItemEdit from './ItemEdit'
import {getSalaryMappingListApi} from './service'
export default {
    mixins:[page_mixins],
    props: {
        enumType: {
            type: String
        }
    },
    data() {
        return {
            list: [],
            params: {
                page: 1,
                per_page: 10,
                search: '',
                total_count: 0,
            },
            loading: false
        }
    },
    computed: {

    
    },
    methods: {
        getListProxy(params = {}) {
            params = {
                ...this.params,
                ...params
            }
            this.loading = true
            getSalaryMappingListApi(params).then(res => {
              this.list = res.mappings
              this.params.total_count = res.total_count
              this.params.per_page = res.per_page
              this.params.page = res.cur_page
            }).finally(() => {
              this.loading = false
            })
          },
    },
    render() {
        return (<div style="padding-bottom:10px">
            <Edit ref="edit" on={{
          
                success:() => {
                    this.getListProxy({
                        page: 1
                    })
                }
            }}/>
            <ItemEdit 
                ref="editItem"
                on={{
          
                    success:(res) => {
                        let target = null
                      
                         // 找到这一条数据
                        this.list.forEach(i => {
                 
                            if (i.id === res.salary_mapping_id) {
                                target = i
                            }
                        });
                        if (!target) {
                            return 
                        }
                        if (!target.salary_title_mappings) {
                            this.$set(target, 'salary_title_mappings', [])
                        }
                        target.salary_title_mappings.forEach((index, item) => {
                            if (res && item.id === res.expense_type) {
                                this.$set(target.salary_title_mappings, index, res)
                                res = null
                            }
                        })
                        if (res) {
                        
                            target.salary_title_mappings.push(res)
                        }

                    }
                }}
            />
               <VBtn 
                    depressed
                    small
                    color="primary"
                    on={{
                      click: () => {
                        this.$refs.edit.edit()
                      }
                    }}
                >
                    新增
                </VBtn>
                <PageContain reserved-height={280}>
                    {this.loading && <VProgressLinear indeterminate color="primary"/>}
                    <div style="height:100%;overflow:auto">
                       {this.list.map(item => <GzItem value={item} on={{
                        edit:(p) => {
                            this.$refs.edit.edit(p)
                        },
                        itemEdit:p => {
                            this.$refs.editItem.edit(p)
                        }
                       }}/>)} 
                    </div>
                    </PageContain>
                    <div class="paginate-fix-bottom" style="z-index:3">
                {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                        this.params.per_page = per_page
                        this.params.page = 1
                        this.$nextTick(this.getListProxy)
                    },
                    pageChange:(page) => {
                        this.params.page = page
                        this.$nextTick(this.getListProxy)
                    }
                  }
                }
              />}
            </div>
            </div>)
    }
}